import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
// import './ZonesTab.css';
import RelaxingAllTable from '../TableComponent/RelaxingAllTable';
import RelaxingOnlyTable from '../TableComponent/RelaxingOnlyTable'




function TabPanel(props) {
  const { children, value, index, ...other } = props;
  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // backgroundColor: 'red',
    // height: '100%'
  },

  tabs: {
    backgroundColor: '#6699ff',
    // backgroundColor: 'pink'
  },

  tabPanel: {
    backgroundColor: '#E8E8E8',
    // background: 'linear-gradient(to top, #5499c7 0%, #6699ff 100%)',
    height: '82vh',   
    
    justifyContent: 'center'
  }
}));

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="fullWidth" indicatorColor="primary" className={classes.tabs}>
          <Tab label="All Zones" {...a11yProps(0)} />
          <Tab label="Relaxing Zones" {...a11yProps(1)} />
          {/* <Tab label="" {...a11yProps(2)} /> */}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} className={classes.tabPanel}>
        <RelaxingAllTable/>
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.tabPanel}>
      <RelaxingOnlyTable/>
      </TabPanel>
      {/* <TabPanel value={value} index={2} className={classes.tabPanel}>
        Item Three
      </TabPanel> */}
    </div>
  );
}
